var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isGrouped)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:(_vm.tooltip),expression:"tooltip",modifiers:{"top":true}}],staticClass:"duration"},[_vm._v(_vm._s(_vm.duration))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }